import { getRequest, postRequest } from "app/axiosClient";
import { showLoader, hideLoader } from "../GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "../ResultNotification/Notification";
import {
  addFile,
  setAttachments,
  clearAddFiles,
  clearDeleteFiles,
} from "./AttachmentsSlice";
export const getAttachments = (id, identifier) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(
      `api/Attachment/GetAttachmentsById?formId=${id}&formTypeId=${identifier}`
    )
      .then((res) => {
        const structured = {
          [identifier]: {
            [id]: res?.data,
          },
        };

        dispatch(setAttachments(structured));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Attachments.Notification.Unexpectederror",
          errorMessage,
          "Attachments.Notification.GetUnexpectederror"
        );
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Attachments.Notification.Unexpectederror",
      "",
      "Attachments.Notification.GetUnexpectederror"
    );
  }
};

export const uploadAttachment = (id) => async (dispatch, getState) => {
  try {
    dispatch(showLoader());

    const state = getState();
    const addFiles = state.Attachments.addFiles;
    const deleteFiles = state.Attachments.deleteFiles;

    const actions = [];

    for (const identifier in addFiles) {
      const files = addFiles[identifier];

      if (files?.length) {
        const payload = {
          formTypeId: identifier,
          formId: id,
          Files: files,
        };

        const uploadAction = postRequest(
          `api/Attachment/UploadAttachments`,
          payload
        )
          .then(() => {
            dispatch(clearAddFiles({ identifier }));

            if (deleteFiles?.length) {
              dispatch(deleteAttachment(deleteFiles));
              dispatch(clearDeleteFiles());
            }
            OpenNotificationWithIcon(
              "success",
              "Common.Success",
              "",
              "Attachments.Notification.UploadSuccessfully"
            );
          })
          .catch((e) => {
            const errorMessage = e?.response?.data || e?.message;
            OpenNotificationWithIcon(
              "error",
              "Attachments.Notification.Unexpectederror",
              errorMessage,
              "Attachments.Notification.saveUnexpectederror"
            );
          });

        actions.push(uploadAction);
      }
    }

    if (actions.length === 0 && deleteFiles?.length) {
      dispatch(deleteAttachment(deleteFiles));
      dispatch(clearDeleteFiles());
    }

    await Promise.all(actions);
  } catch (error) {
    OpenNotificationWithIcon(
      "error",
      "Attachments.Notification.Unexpectederror",
      "",
      "Attachments.Notification.saveUnexpectederror"
    );
  } finally {
    dispatch(hideLoader());
  }
};

export const signatureUploadAttachment = (id) => async (dispatch, getState) => {
  try {
    dispatch(showLoader());

    const state = getState();
    const addFiles = state.Attachments.addFiles;
    const deleteFiles = state.Attachments.deleteFiles;

    const actions = [];

    for (const identifier in addFiles) {
      const files = addFiles[identifier];

      if (files?.length) {
        const payload = {
          formTypeId: identifier,
          formId: id,
          Files: files,
        };

        const uploadAction = postRequest(
          `api/Attachment/SignatureUploadAttachments`,
          payload
        )
          .then(() => {
            dispatch(clearAddFiles({ identifier }));

            if (deleteFiles?.length) {
              dispatch(deleteAttachment(deleteFiles));
              dispatch(clearDeleteFiles());
            }
            OpenNotificationWithIcon(
              "success",
              "Common.Success",
              "",
              "Attachments.Notification.UploadSuccessfully"
            );
          })
          .catch((e) => {
            const errorMessage = e?.response?.data || e?.message;
            OpenNotificationWithIcon(
              "error",
              "Attachments.Notification.Unexpectederror",
              errorMessage,
              "Attachments.Notification.saveUnexpectederror"
            );
          });

        actions.push(uploadAction);
      }
    }

    if (actions.length === 0 && deleteFiles?.length) {
      dispatch(deleteAttachment(deleteFiles));
      dispatch(clearDeleteFiles());
    }

    await Promise.all(actions);
  } catch (error) {
    OpenNotificationWithIcon(
      "error",
      "Attachments.Notification.Unexpectederror",
      "",
      "Attachments.Notification.saveUnexpectederror"
    );
  } finally {
    dispatch(hideLoader());
  }
};

export const deleteAttachment = (payload) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Attachment/DeleteAttachmentById`, payload)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Attachments.Notification.DeleteSuccessfully"
        );
        return true;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Attachments.Notification.Unexpectederror",
          errorMessage,
          "Attachments.Notification.DeleteUnexpectederror"
        );
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Attachments.Notification.Unexpectederror",
      "",
      "Attachments.Notification.DeleteUnexpectederror"
    );
    return false;
  }
};
export const getAttachmentsList = (formTypeId, formId) => async (dispatch) => {
  try {
    dispatch(showLoader());

    const res = await getRequest(
      `api/Attachment/GetAttachmentsById?formId=${formId}&formTypeId=${formTypeId}`
    );
    dispatch(setAttachments(res.data));
    dispatch(hideLoader());
    return res.data;
  } catch (e) {
    dispatch(hideLoader());

    OpenNotificationWithIcon(
      "error",
      "Attachments.Notification.Unexpectederror",
      "",
      "Attachments.Notification.DeleteUnexpectederror"
    );

    return false;
  }
};
